import type { ChatMessage } from '../data/chatTypes';

/** Only explicit clarification turns loop; narrative arbitrations and quizzes remain exclusive. */
export function isExploration(q: ChatMessage | undefined): boolean {
  return q?.type === 'dialogue-choice' && q.exploreAll === true;
}

export function remainingTopics(q: ChatMessage, attempted: string[]): string[] {
  return (q.options ?? []).filter(label => !attempted.includes(label));
}

export function exploreTopic(q: ChatMessage, attempted: string[], choice: string) {
  if (!isExploration(q) || !remainingTopics(q, attempted).includes(choice)) return null;
  const used = [...attempted, choice];
  return { used, remaining: remainingTopics(q, used), reply: q.optionResponses?.[choice] ?? '' };
}
